import * as React from "react";
import { useContext } from "react";
import { useState } from "react";
import { toast, Zoom } from "react-toastify";
import { Org_PageList_Details } from "../../api/Organization Api/OrganizationApi";
import { THEME_SELECT } from "../../constant";
import LoaderContext from "../LoaderContext/LoaderContext";
import BrokercomponetContext from "./BrokercomponetContext";

const BrokerComponentState = (props) => {
  const [email, setEmail] = useState(null);
  const [fname, setFname] = useState(null);
  const [lname, setLname] = useState(null);
  const [pagetitle, setPageTitle] = useState(null);
  const [orgName, setOrgName] = useState(null);
  const [designation, setDesignation] = useState(null);
  const [address, setAddress] = useState(null);
  const [conuntry, setConuntry] = useState(null);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [logo, setLogo] = useState(null);
  const [seoTitle, setSeoTitle] = useState(null);
  const [seoDescription, setSeoDescription] = useState(null);
  const [seoKey, setSeoKey] = useState(null);
  const [theme, setTheme] = useState(null);
  const [color, setColor] = useState(null);
  const [dialCode, setDialCode] = useState("+91");
  const [slugUrl, setSlugUrl] = useState("");
  const [blockerSlugUrl, setBlockerSlugUrl] = useState("");
  const [actionQpiId, setActionQpiId] = useState(0);
  const [type, setType] = useState("");
  const [isDialog, setIsDialog] = useState(false);
  const [isFource, setIsFource] = useState(false);
  const [isLabel, setIsLabel] = useState("");
  const [filter, setFilter] = useState("");

  /** user State */

  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [mobile, setMobile] = useState(null);
  const [isShowBranch, setIsShowBranch] = useState(false);
  const [isBranchLabel, setIsBranchLabel] = useState("");

  const [check, setCheck] = useState(true);

  const [editIndex, seteditIndex] = useState(-1); //EDIT -->
  const [isAddHandle, setIsAddHandle] = useState(true);
  const [pageUuid, setPageUuid] = useState("");
  const [formvalue, setformValue] = useState([]);

  const [togglesubmit, setToggleSubmit] = useState(false);
  const [modal, setModal] = useState(false);
  const [landingDropdownData, setLandingDropdownData] = useState([]);
  const [data, setData] = useState([]);
  const [themeData, setThemeData] = useState([]);

  const [currentColor, setCurrentColor] = useState("#ff6");
  const appStyle = {
    backgroundColor: currentColor,
  };

  const { loaderShow, setLoaderShow } = useContext(LoaderContext);

  const FillFeild = async (pageUuid, orgId) => {
    setPageUuid(pageUuid);
    setLoaderShow(!loaderShow);
    try {
      const { data } = await Org_PageList_Details(pageUuid);
      if (data.status === 200) {
        seteditIndex(orgId);
        setIsAddHandle(false);
        const payload = data.payload.data;
        await setData(
          payload.landingPageDetails.map((elem) => {
            return {
              value: elem.pageId,
              label:
                elem.pageDetailForLanding &&
                elem.pageDetailForLanding.pageTitle,
            };
          })
        );
        setThemeData(
          THEME_SELECT.filter((elem) => payload.templateId === elem.value)
        );
        setEmail(payload.email ? payload.email : null);
        setFname(payload.fname ? payload.fname : null);
        setLname(payload.lname ? payload.lname : null);
        setPageTitle(payload.pageTitle ? payload.pageTitle : null);
        setOrgName(payload.orgName ? payload.orgName : null);
        setDesignation(payload.designation ? payload.designation : null);
        setAddress(payload.address ? payload.address : null);
        setConuntry(payload.country ? payload.country : null);
        setState(payload.state ? payload.state : null);
        setCity(payload.city ? payload.city : null);
        setLogo(payload.orgLogo ? payload.orgLogo : null);
        setSeoDescription(payload.seoDesc ? payload.seoDesc : null);
        setSeoKey(payload.seoKeyword ? payload.seoKeyword : null);
        setSeoTitle(payload.seoTitle ? payload.seoTitle : null);
        setDialCode(payload.dialCode ? payload.dialCode : "+91");
        setSlugUrl(
          payload.slugUrl ? payload.slugUrl.replace(/\s+/g, "-") : null
        );
        setBlockerSlugUrl(
          payload.blockerSlugUrl
            ? payload.blockerSlugUrl.replace(/\s+/g, "-")
            : null
        );
        setIsDialog(payload.config.isDialog);
        setIsFource(payload.config.isFource);
        setIsLabel(payload.config.isLabel);
        setIsShowBranch(payload.config.is_show_branch);
        setIsBranchLabel(payload.config.branch_label);
        setUserEmail(payload.userEmail ? payload.userEmail : null);
        setMobile(payload.mobile ? payload.mobile : null);
        // if (payload.pageThemeConfig) {
        //   let a = payload.pageThemeConfig;
        //   a = JSON.parse(a);
        //   setTheme(a.themeColor);
        //   setColor(a.fontColor);
        // }
        setTheme(payload.pageThemeConfig.themeColor);
        setColor(payload.pageThemeConfig.fontColor);
        setLoaderShow(false);
      } else {
      }
    } catch (error) {
      toast.error(error.response, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };

  return (
    <>
      <BrokercomponetContext.Provider
        value={{
          email,
          setEmail,
          fname,
          setFname,
          lname,
          setLname,
          pagetitle,
          setPageTitle,
          orgName,
          setOrgName,
          designation,
          setDesignation,
          address,
          setAddress,
          conuntry,
          setConuntry,
          state,
          setState,
          city,
          setCity,
          logo,
          setLogo,
          seoTitle,
          setSeoTitle,
          seoDescription,
          setSeoDescription,
          seoKey,
          setSeoKey,
          check,
          setCheck,
          theme,
          setTheme,
          color,
          setColor,
          landingDropdownData,
          setLandingDropdownData,
          data,
          setData,
          themeData,
          setThemeData,
          dialCode,
          setDialCode,

          password,
          setPassword,
          confirmPassword,
          setConfirmPassword,
          userEmail,
          setUserEmail,
          mobile,
          setMobile,

          FillFeild,
          editIndex,
          seteditIndex,
          isAddHandle,
          setIsAddHandle,
          formvalue,
          setformValue,
          togglesubmit,
          setToggleSubmit,
          modal,
          setModal,
          pageUuid,
          currentColor,
          setCurrentColor,
          appStyle,
          slugUrl,
          setSlugUrl,
          blockerSlugUrl,
          setBlockerSlugUrl,
          actionQpiId,
          setActionQpiId,
          type,
          setType,
          isDialog,
          setIsDialog,
          isFource,
          setIsFource,
          isLabel,
          setIsLabel,
          isShowBranch,
          setIsShowBranch,
          isBranchLabel,
          setIsBranchLabel,
          filter,
          setFilter,
        }}
      >
        {props.children}
      </BrokercomponetContext.Provider>
    </>
  );
};

export default BrokerComponentState;
